"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hidden = exports.transparent = exports.wrapper = void 0;

var react_1 = require("@emotion/react");

exports.wrapper = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  display: inline-flex;\n  overflow: hidden;\n  justify-content: center;\n  align-items: center;\n  width: inherit;\n  height: inherit;\n  min-width: inherit;\n  min-height: inherit;\n  border-radius: inherit;\n  background-color: var(--gray-80);\n  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1);\n"])));
exports.transparent = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  opacity: 0;\n"])));
exports.hidden = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: none;\n"])));